import { z } from 'zod'

/**
 * Staff roles for the ops console. Mirrors `StaffRole` in
 * `api/prisma/schema.prisma`.
 *
 * The ops console is deliberately not tenant-scoped — it exists to support every
 * calling app — so it is the one surface where a single account can reach every
 * tenant's documents. `SUPPORT` covers the read-only work that makes up most of
 * that job; `ADMIN` is required for anything that changes an envelope or pulls
 * signed artifacts out of the system.
 */
export const STAFF_ROLES = ['ADMIN', 'SUPPORT'] as const

export const staffRoleSchema = z.enum(STAFF_ROLES)

export type StaffRole = z.infer<typeof staffRoleSchema>

export const STAFF_ROLE_FROM_PRISMA = {
  ADMIN: 'ADMIN',
  SUPPORT: 'SUPPORT',
} as const satisfies Record<StaffRole, StaffRole>
